import React, { useState } from 'react'
import {
  FormDashboardLabel as Label,
  ArrayChecker,
  FormRow,
} from '../../../components'
// import { FileAdder } from './file-adder'
import { FormResourceType } from './form-resource-type'
import { deleteFile } from '../../../features/resource-form/service'
import { fetchResource } from '../../../features/resource/slice'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { useInternationalization } from '../../../features/i18n'

const FormOptions = () => {
  const dispatch = useDispatch()
  const { translate, language } = useInternationalization()
  const form = useSelector(state => state.resourceForm.data)
  const resourceTypesById = useSelector(state => state.system.resourceTypesById)
  const { files } = form
  const [requesting, setRequesting] = useState(false)

  // @todo: handle external link resource type
  console.log({files})

  const handleDeleteFile = (file) => {
    if(file.id){
      if(requesting === false){
        setRequesting(true)

        deleteFile(file.id)
          .then(() => {
            dispatch(fetchResource(form.id))
          })
          .catch(err => {
            toast.error(err)
          })
          .finally(() => setRequesting(false))
      } else {
        toast.info('Another request is on process. Please wait...')
      }
    } else {
      toast.error('Error 400: file id is not provided.')
    }
  }

  return (
    <>
      <hr className="mb-8"/>

      <p className="text-lg font-bold mb-5 lg:mb-8">
        {translate('RESOURCE', 'options')}
      </p>

      <FormRow>
        <Label>{translate('GENERAL', 'file')}</Label>
        <ArrayChecker data={files}>
          <div className="space-y-2">
            {
              files && files.map((file, index) => (
                <div className="border p-4 rounded flex justify-between text-sm" key={index}>
                  <div>
                    <div>ID: {file.id}</div>
                    <div>{translate('SEARCH', 'type')}: {resourceTypesById[file.type]?.name[language.name]}</div>
                  </div>
                  {
                    (file.url && file.url.includes('/assets/file.pdf') === false) &&
                    <div>
                      <a
                        className="link underline"
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={file.url}
                      >
                        File Link
                      </a>
                    </div>
                  }
                  {
                    (file.embedLink &&
                    file.embedLink !== '' &&
                    file.embedLink !== 'https://' &&
                    file.embedLink !== 'N/A') &&
                    <div>
                      <a
                        className="link underline"
                        href={file.embedLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={file.embedLink}
                      >
                        Embed/External Link
                      </a>
                    </div>
                  }
                  <div>
                    <p
                      className="underline text-sm cursor-pointer opacity-50 hover:opacity-100"
                      onClick={() => handleDeleteFile(file)}
                    >
                      {translate('GENERAL', 'delete')}
                    </p>
                  </div>
                </div>
              ))
            }
          </div>
        </ArrayChecker>
      </FormRow>

      <FormResourceType />

      {/* <FileAdder form={form} updateForm={updateForm}/> */}
    </>
  )
}

export { FormOptions }
